import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "rocklink.tableDensity";
const VALID = ["compact", "comfortable"];
const DEFAULT_DENSITY = "comfortable";

const DENSITY_CONFIG = {
  compact: {
    isCompact: true,
    descTh: "w-[320px]",
    descMaxW: "max-w-[300px]",
    descFont: "text-[11px]",
  },
  comfortable: {
    isCompact: false,
    descTh: "w-[300px]",
    descMaxW: "max-w-[280px]",
    descFont: "text-[13px]",
  },
};

export function useTableDensity() {
  const [density, setDensityState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_DENSITY;
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return VALID.includes(stored) ? stored : DEFAULT_DENSITY;
  });

  const setDensity = useCallback((next) => {
    if (!VALID.includes(next)) return;
    setDensityState(next);
    try { window.localStorage.setItem(STORAGE_KEY, next); } catch (_e) { /* ignore */ }
    try { window.dispatchEvent(new CustomEvent("rl-density", { detail: next })); } catch (_e) { /* ignore */ }
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY && VALID.includes(e.newValue)) {
        setDensityState(e.newValue);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  useEffect(() => {
    const onDensity = (e) => { if (VALID.includes(e.detail)) setDensityState(e.detail); };
    window.addEventListener("rl-density", onDensity);
    return () => window.removeEventListener("rl-density", onDensity);
  }, []);

  return { density, setDensity, config: DENSITY_CONFIG[density] };
}

export const DENSITY_OPTIONS = VALID;
